import React from 'react'
import ReactDOM from 'react-dom'
import '../../assets/js/polyfill'

import FragmentWrapper from '../FragmentWrapper'
import Footer from './Footer'

import { TFooterState } from '../../server/footerMiddleware/footerMiddleware'

const state: TFooterState = JSON.parse(document.getElementById(`x-ui-fragment-footer-state`)?.innerHTML ?? '{}')

ReactDOM.hydrate(
  <FragmentWrapper assetsUrl={state.assetsUrl} assetHash={state.assetHash} name={'footer'}>
    <Footer isReduced={state.isReduced} tickers={state.tickers} locale={state.locale} />
  </FragmentWrapper>,
  document.getElementById('x-ui-fragment-footer-root'),
)
